var React = require('react');

function ArrowsCompressIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","clipRule":"evenodd","fill":"currentColor"},React.createElement("path",{"d":"M8.333 7.5c0 .46-.373.833-.833.833H3.333a.833.833 0 0 1 0-1.666h3.334V3.333a.833.833 0 0 1 1.666 0V7.5ZM11.667 7.5c0 .46.373.833.833.833h4.167a.833.833 0 0 0 0-1.666h-3.334V3.333a.833.833 0 0 0-1.666 0V7.5ZM11.91 11.91a.834.834 0 0 1 .59-.243h4.167a.833.833 0 0 1 0 1.666h-3.334v3.334a.833.833 0 0 1-1.666 0V12.5c0-.221.088-.433.244-.59ZM8.09 11.91a.834.834 0 0 0-.59-.243H3.333a.833.833 0 0 0 0 1.666h3.334v3.334a.833.833 0 0 0 1.666 0V12.5a.833.833 0 0 0-.244-.59Z"})));
}

ArrowsCompressIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ArrowsCompressIcon;

ArrowsCompressIcon.default = ArrowsCompressIcon;
